export const BACKOFFICE_ROLE = 'BCK_ADMIN';

export const getMedicalRoles = (roles = []) =>
    roles.filter((role) => role.name !== BACKOFFICE_ROLE);

export const getUniqueClinics = (roles = []) => {
    const clinics = new Map();

    roles.forEach((role) => {
        if (role.account?.uuid) clinics.set(role.account.uuid, role.account);
    });

    return [...clinics.values()];
};

export const getRolesForClinic = (roles = [], clinicUuid) =>
    roles.filter((role) => role.account?.uuid === clinicUuid);

export const resolveStoredAccess = ({ roles = [], roleUuid, clinic }) => {
    if (!roleUuid) {
        const storedClinic = clinic?.uuid
            ? getUniqueClinics(roles).find(
                  (availableClinic) => availableClinic.uuid === clinic.uuid
              )
            : null;
        return { isValid: false, role: null, clinic: storedClinic || null };
    }

    const role = roles.find((candidate) => candidate.uuid === roleUuid);
    if (!role) return { isValid: false, role: null, clinic: null };

    if (!role.account?.uuid) {
        return { isValid: true, role, clinic: null };
    }

    if (!clinic?.uuid || clinic.uuid !== role.account.uuid) {
        return { isValid: false, role: null, clinic: null };
    }

    return { isValid: true, role, clinic: role.account };
};
